module.exports = __webpack_public_path__ + "static/media/clockface-light.324afd0e.png";